<app-media-page
  [intervention]="intervention"
  [hasAdminPermissions]="hasAdminPermissions"
  [interventionId]="intervention?._id"
  [isInterventionRequired]="true"
  [mediaPageLocation]="MediaPageLocation.intervention"
  [edithMode]="true"
></app-media-page>
